import React, { useCallback } from 'react'
import { isPast } from 'date-fns'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import FieldLabelWrapper from '../../../features/components/Form/FieldLabelWrapper'
import DatePicker from '../../../components/DatePicker'
import TimePicker from '../../../components/TimePicker'

import { START_DATE, START_TIME, STOP_DATE, STOP_TIME } from '../../Multiplatform/LineItemForms/fields'

import useStyles from './styles'

const StartEndTimeFields = ({
  formik,
  indefiniteText = 'This ad set has been set up to run indefinitely until paused.'
}) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { setFieldValue, values } = formik

  const isStartDateInPast = isPast(new Date(values[START_DATE]))

  const handleStartDatePickerChange = useCallback(
    value => {
      setFieldValue(START_DATE, value)
    },
    [setFieldValue]
  )

  const handleStartTimePickerChange = useCallback(
    value => {
      setFieldValue(START_TIME, value || '00:00')
    },
    [setFieldValue]
  )

  const handleStopDatePickerChange = useCallback(
    value => {
      setFieldValue(STOP_DATE, value)
    },
    [setFieldValue]
  )

  const handleStopTimePickerChange = useCallback(
    value => {
      setFieldValue(STOP_TIME, value || '00:00')
    },
    [setFieldValue]
  )

  return (
    <>
      <FieldLabelWrapper label={t('Start Date')} contentClassName={classes.dateFieldsWrapper}>
        <DatePicker
          placeholder={t('Start Date')}
          value={values[START_DATE]}
          changeHandler={handleStartDatePickerChange}
          disabled={isStartDateInPast}
        />
        <TimePicker
          value={values[START_TIME]}
          changeHandler={handleStartTimePickerChange}
          disabled={isStartDateInPast}
        />
      </FieldLabelWrapper>

      {/*END DATE*/}
      <FieldLabelWrapper label={t('End Date')} contentClassName={classes.dateFieldsWrapper}>
        {values[STOP_DATE] ? (
          <>
            <DatePicker
              title={t('End Date')}
              value={values[STOP_DATE]}
              changeHandler={handleStopDatePickerChange}
              minDate={isStartDateInPast ? new Date() : values[START_DATE]}
            />
            <TimePicker value={values[STOP_TIME]} changeHandler={handleStopTimePickerChange} />
          </>
        ) : (
          <p>{t(indefiniteText)}</p>
        )}
      </FieldLabelWrapper>
    </>
  )
}

StartEndTimeFields.propTypes = {
  formik: PropTypes.object.isRequired,
  indefiniteText: PropTypes.string
}

export default StartEndTimeFields
